const USER = {
	LOAD: 'USER_LOAD',
	LOAD_SUCCESS: 'USER_LOAD_SUCCESS',
	LOAD_FAIL: 'USER_LOAD_FAIL',
	RESET: 'USER_RESET',
};

const APPS = {
	LOAD: 'APPS_LOAD',
	LOAD_OVERVIEW_SUCCESS: 'APPS_LOAD_OVERVIEW_SUCCESS',
	LOAD_OVERVIEW_FAIL: 'APPS_LOAD_OVERVIEW_FAIL',
	LOAD_METRICS_SUCCESS: 'APPS_LOAD_METRICS_SUCCESS',
	LOAD_METRICS_FAIL: 'APPS_LOAD_METRICS_FAIL',
	APPEND: 'APPS_APPEND',
	LOAD_OWNERS: 'APPS_LOAD_OWNERS',
	LOAD_OWNERS_SUCCESS: 'APPS_LOAD_OWNERS_SUCCESS',
	LOAD_OWNERS_FAIL: 'APPS_LOAD_OWNERS_FAIL',
	DELETE_APP: 'DELETE_APP',
};

const CREATE_APP = {
	LOAD: 'CREATING_APP',
	LOAD_SUCCESS: 'CREATE_APP_SUCCESS',
	LOAD_FAIL: 'CREATE_APP_FAIL',
	RESET: 'CREATE_APP_RESET',
};

const TYPE_FORM = {
	UNLOADED: 0,
	LOADED: 1,
	SUBMITTED: 2,
};

const STRIPE_KEY = {
	TEST: 'pk_test_DYtAxDRTg6cENksacX1zhE02',
	LIVE: 'pk_live_ihb1fzO4h1ykymhpZsA3GaQR',
};

export { USER, APPS, CREATE_APP, STRIPE_KEY, TYPE_FORM };
